import { render, staticRenderFns } from "./AbsenseStatistics.vue?vue&type=template&id=adee3c72&"
import script from "./AbsenseStatistics.vue?vue&type=script&lang=js&"
export * from "./AbsenseStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports